import * as Yup from 'yup';

export const emailSchema = Yup.object().shape({
  email: Yup.string()
    .required('email.required')
    .email('email.invalid')
    .matches(/\w{2}$/, 'email.invalid')
});
